import type { TImage, TImageLoading } from "../../../types";
import styles from "./contact-card-v2.module.less";

export type TContactCardV2Props = {
  name: string;
  title?: string;
  geographicAreas?: string;
  phone?: string;
  phone2?: string;
  phone3?: string;
  email?: string;
  image?: TImage;
  imageLoading?: TImageLoading;
};

export const ContactCardV2 = ({
  title,
  name,
  geographicAreas,
  phone,
  phone2,
  phone3,
  email,
  image,
  imageLoading,
}: TContactCardV2Props) => {
  return (
    <div className={styles.wrapper}>
      {image?.url && <img src={image.url} alt={image.alt || name} className={styles.image} loading={imageLoading} />}
      <div className={styles.contentWrapper}>
        <div className={styles.identificationSection}>
          <p className={[styles.name, "body-base bold mb-0"].join(" ")}>{name}</p>
          {title && <p className={[styles.jobTitle, "body-s my-0"].join(" ")}>{title}</p>}
          {geographicAreas && <p className={[styles.geographicAreas, "body-s my-0"].join(" ")}>{geographicAreas}</p>}
        </div>
        <div className={styles.contactSection}>
          {email && (
            <a href={`mailto:${email}`} className={["body-s mb-0", styles.link].join(" ")}>
              {email}
            </a>
          )}
          {phone && (
            <a href={`tel:${phone}`} className={["body-s mb-0", styles.link].join(" ")}>
              {phone}
            </a>
          )}
          {phone2 && (
            <a href={`tel:${phone2}`} className={["body-s mb-0", styles.link].join(" ")}>
              {phone2}
            </a>
          )}
          {phone3 && (
            <a href={`tel:${phone3}`} className={["body-s mb-0", styles.link].join(" ")}>
              {phone3}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export const ContactCardV2Content = (props: TContactCardV2Props) => {
  return (
    <div className={"space-my-sm"}>
      <ContactCardV2 {...props} />
    </div>
  );
};

export default ContactCardV2;
